/**
 * Translates 10m in 6000 milliseconds
 */
function getMilliseconds(str) {
  let milli = 0;
  let seconds = str.match(/(\d+)\s*s/);
  let days = str.match(/(\d+)\s*d/);
  let hours = str.match(/(\d+)\s*h/);
  let minutes = str.match(/(\d+)\s*m/);

  if (days) {
    milli += parseInt(days[1]) * 86400000;
  }
  if (hours) {
    milli += parseInt(hours[1]) * 3600000;
  }
  if (minutes) {
    milli += parseInt(minutes[1]) * 60000;
  }
  if (seconds) {
    milli += parseInt(seconds[1]) * 1000;
  }

  return milli;
}

export default getMilliseconds;
